// El Test Alpha y el Planificador: enviar, consultar resultados, plan de estudio.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { API, api } from "./client";

export const submitTest = async ({ email, name, answers, test }) => {
  const { data } = await api.post("/test/submit", { email, name, answers, test });
  return data;
};

export const getResult = async (id) => {
  const { data } = await api.get(`/test/results/${id}`);
  return data;
};

export const getStats = async () => {
  const { data } = await api.get("/test/stats");
  return data;
};

// ---- Planificador Alpha (test → resultados → plan) ----

export const generateStudyPlan = async (resultId) => {
  const { data } = await api.post("/planner/generate", { result_id: resultId });
  return data;
};

// ---- Historial de tests del alumno + PDF ----

export const getMyTests = async () => {
  const { data } = await api.get("/test/mine");
  return data;
};

export const getResultPdfUrl = (resultId) => `${API}/test/results/${resultId}/pdf`;
